var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSteamGameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.654 12.801a1.285 1.285 0 0 0 .715-2.356L4.357 9.77a2.064 2.064 0 0 1 2.606 1.99 2.062 2.062 0 0 1-4.123.09l1.101.735c.22.146.468.216.713.216ZM13.067 0a2.621 2.621 0 0 1 2.613 2.614v10.452a2.62 2.62 0 0 1-2.613 2.614H2.614A2.62 2.62 0 0 1 0 13.066V9.958l1.858 1.238a3.094 3.094 0 1 0 6.088.023l3.814-3.414A3.43 3.43 0 1 0 7.875 3.92L4.741 8.67c-.488.025-.97.165-1.405.42L0 6.866V2.614A2.621 2.621 0 0 1 2.614 0h10.453Zm.653 4.41a2.45 2.45 0 1 0-4.9 0 2.45 2.45 0 0 0 4.9 0Zm-3.92 0a1.47 1.47 0 1 1 2.94 0 1.47 1.47 0 0 1-2.94 0Z",
  id: "SteamGameIcon_svg__a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .5)",
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3B3B3B",
  xlinkHref: "#SteamGameIcon_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#757575",
  xlinkHref: "#SteamGameIcon_svg__a"
}))));

export default SvgSteamGameIcon;